import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/BreakdownTemplates'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class BreakdownTemplatesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "BreakdownTemplatesStore",
			variables: true,
		})
	}
}

export async function load_BreakdownTemplates(params) {
  await initClient()

	const store = new BreakdownTemplatesStore()

	await store.fetch(params)

	return {
		BreakdownTemplates: store,
	}
}
